










































import {Component, Prop, Provide, Vue, Watch} from 'vue-property-decorator'
import {InputText, InputCheckbox} from 'simpli-web-sdk'
import {ITipoClienteResourcesHolder} from '@/interfaces/resource/ITipoClienteResourcesHolder'
import {TipoCliente as TipoClienteEnum} from '@/enums/TipoCliente'
import {TipoCliente} from '@/model/resource/TipoCliente'
import {TipoClienteCollection} from '@/model/collection/TipoClienteCollection'
import {PanelUser} from '@/model/resource/PanelUser'
import {PanelUserType} from '@/model/resource/PanelUserType'
import {PanelUserInfo} from '@/model/resource/PanelUserInfo'
import {Validator} from '@brazilian-utils/brazilian-utils/dist/utilities/inscricao-estadual/validators/validator'

@Component({
  components: {InputText, InputCheckbox},
})
export default class InputTipoClienteInternational extends Vue {
  resourceHolder = TipoClienteCollection.listTipoCliente()
  @Prop({type: Object, required: true}) model!: PanelUserInfo
  @Prop({type: String, default: null}) optionValue!: string | null
  @Prop({type: Object, required: true}) validator!: Validator | null

  TipoCliente = TipoClienteEnum

  async created() {
    if (!this.model.idPanelUserTypeFk) {
      this.model.idPanelUserTypeFk = this.TipoCliente.Cliente
    }
  }

  get computedModel() {
    return this.model
  }

  set computedModel(val: PanelUserInfo) {
    this.$emit('input', val)
  }

  get option() {
    return this.optionValue
  }

  set option(val: string | number | null) {
    this.$emit('updateOption', val)
  }

  isTipoClienteChecked(tipoCliente: TipoCliente) {
    return this.computedModel.idPanelUserTypeFk === tipoCliente.idTipoClientePk
  }

  checkTipoCliente(tipoCliente: TipoCliente) {
    this.computedModel.idPanelUserTypeFk = tipoCliente.idTipoClientePk
  }
}
